import { Dialog } from "primereact/dialog";
import { FileUpload } from "primereact/fileupload";
import Button from "../../componentes/button/button";

export default function ImportarBPModal({
    show,
    close,
    importarExcel,
    loadingImport,
    importMessage
}) {
    
    return (
        <Dialog
            header="Importar Planilha"
            visible={show}
            onHide={close}
            className="w-[95%] md:w-[60%]"
            modal
        >
            <div className="space-y-6 py-2">

                {importMessage ?
                    <>
                        {importMessage.status === 200 ?
                            <div className="bg-success/10 border-l-4 border-success text-success p-4 rounded-lg">
                                <p className="font-semibold text-sm">✅ Importação Finalizada:</p>
                                <p className="text-sm">
                                    <pre>
                                        {importMessage?.data}
                                    </pre>
                                </p>
                            </div>
                            :
                              <div className="bg-destructive/10 border-l-4 border-destructive text-destructive p-4 rounded-lg">
                                <p className="font-semibold text-sm">⚠️ Atenção:</p>
                                <p className="text-sm">
                                    Não altere a ordem das colunas ou linhas da planilha exportada.
                                    Preencha apenas os valores dos meses (Janeiro a Dezembro) e, em
                                    seguida, reimporte o arquivo para o sistema.
                                </p>
                            </div>
                        }
                    </>
                    :
                    <div className="bg-yellow-50 border-l-4 border-yellow-500 text-yellow-800 p-4 rounded-lg">
                        <p className="font-semibold text-sm">⚠️ Atenção:</p>
                        <p className="text-sm">
                            Não altere a ordem das colunas ou linhas da planilha exportada.
                            Preencha apenas os valores dos meses (Janeiro a Dezembro) e, em
                            seguida, reimporte o arquivo para o sistema.
                        </p>
                    </div>
                }
                {/* 🔘 Upload */}
                <div className="flex flex-col md:flex-row items-center gap-4 w-full">
                    <ExcelUpload
                        onUpload={importarExcel}
                        loading={loadingImport}
                    />
                </div>

                {/* FOOTER */}
                <div className="flex justify-end gap-3 pt-2">
                    <Button
                        variant="white"
                        label="Fechar"
                        onClick={close}
                    />
                </div>
            </div>
        </Dialog>
    );
}


function ExcelUpload({
    onUpload,
    loading,
    label = "Importar Planilha Excel"
}) {
    return (
        <FileUpload
            name="file"
            accept=".xlsx"
            maxFileSize={10000000}
            customUpload
            disabled={loading}
            uploadHandler={onUpload}
            chooseLabel="Selecionar Planilha"
            uploadLabel="Confirmar Importação"
            uploadOptions={{ icon: "fa fa-check", className: "text-success mr-3" }}
            cancelOptions={{ icon: "fa fa-times", className: "text-destructive" }}
            cancelLabel="Cancelar"
            className="w-full border border-input rounded-md"
            chooseOptions={{
                icon: "fa fa-plus",
                label,
                className:
                    "bg-primary text-primary-foreground hover:brightness-95 border-none px-4 py-2 rounded-lg transition-colors duration-150",
            }}
        />
    );
}